/**
 * Business rules that adjust scene availability after the API-sourced
 * availability has been assigned.
 *
 * Currently a no-op placeholder. When the API begins providing roadshow
 * or studio-specific availability constraints, this function should
 * apply those rules (e.g. marking certain scenes as "studio-only").
 *
 * Separated from the content layer because availability is a business
 * concern, not a display concern.
 */
import type { SceneAvailability } from '@/components/SceneSelection/types'

export interface SceneAvailabilityRule {
  sceneId: string
  availability: SceneAvailability
}

/**
 * Returns availability adjustments for the given session type.
 * Currently returns an empty array — no rules are active.
 *
 * TODO: Wire to API-sourced roadshow/studio constraints when available.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getSceneAvailabilityRules(sessionTypeKey: string): SceneAvailabilityRule[] {
  return []
}
